import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, QrCode, CalendarDays, Megaphone, Heart, LogOut } from "lucide-react";
import { Logo } from "../common/Logo";
import { useAuth } from "../../contexts/AuthContext";

const items = [
  { to: "/camper", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/camper/qr", icon: QrCode, label: "QR", testid: "nav-qr" },
  { to: "/camper/schedule", icon: CalendarDays, label: "Schedule", testid: "nav-schedule" },
  { to: "/camper/announcements", icon: Megaphone, label: "News", testid: "nav-news" },
  { to: "/camper/feedback", icon: Heart, label: "Feedback", testid: "nav-feedback" },
];

export default function CamperShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FFF4E6] pb-24">
      <header className="sticky top-0 z-40 bg-[#FFF4E6]/90 backdrop-blur-md border-b-2 border-[#3D1E6D]">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Logo size="sm" />
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right leading-tight">
              <div className="text-xs font-bold tracking-widest uppercase text-[#6B4E9E]">
                Camper
              </div>
              <div className="text-sm font-bold text-[#3D1E6D]" data-testid="header-user-name">
                {user?.name}
              </div>
            </div>
            <button
              onClick={() => {
                logout();
                navigate("/");
              }}
              className="kf-border bg-white p-2 hover:bg-[#FFB400] transition-colors"
              data-testid="logout-button"
              aria-label="Logout"
            >
              <LogOut className="h-4 w-4" strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6">
        <Outlet />
      </main>

      <nav
        className="fixed bottom-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-t-2 border-[#3D1E6D]"
        data-testid="bottom-nav"
      >
        <div className="max-w-3xl mx-auto grid grid-cols-5">
          {items.map(({ to, icon: Icon, label, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/camper"}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
                  isActive ? "text-[#E5247C]" : "text-[#3D1E6D]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div
                    className={`p-1.5 ${
                      isActive ? "bg-[#FFB400] kf-border" : ""
                    }`}
                  >
                    <Icon className="h-5 w-5" strokeWidth={2.75} />
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-wider">
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
